var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.028 6.084c0-.234 0-.35-.045-.44a.417.417 0 0 0-.182-.182c-.09-.045-.206-.045-.44-.045H9.64c-.233 0-.35 0-.439.045a.417.417 0 0 0-.182.183c-.045.089-.045.205-.045.439v1.722c0 .233 0 .35-.046.439a.416.416 0 0 1-.182.182c-.09.046-.206.046-.44.046H6.585c-.234 0-.35 0-.44.045a.417.417 0 0 0-.182.182c-.045.09-.045.206-.045.44v1.721c0 .234 0 .35.045.44.04.078.104.142.183.182.089.045.205.045.439.045h1.722c.233 0 .35 0 .439.045.078.04.142.104.182.183.046.089.046.205.046.439v1.722c0 .233 0 .35.045.44.04.078.104.141.182.181.09.046.206.046.44.046h1.721c.234 0 .35 0 .44-.046a.417.417 0 0 0 .182-.182c.045-.089.045-.206.045-.439v-1.722c0-.234 0-.35.045-.44a.417.417 0 0 1 .183-.182c.089-.045.205-.045.439-.045h1.722c.233 0 .35 0 .44-.045a.417.417 0 0 0 .181-.182c.046-.09.046-.206.046-.44V9.14c0-.233 0-.35-.046-.439a.416.416 0 0 0-.182-.182c-.089-.045-.206-.045-.439-.045h-1.722c-.234 0-.35 0-.44-.046a.417.417 0 0 1-.182-.182c-.045-.09-.045-.206-.045-.44V6.085z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCircle);
export default __webpack_public_path__ + "static/media/medicalCircle.21d4ece3aef3df157ab8d12b764bb5bf.svg";
export { ForwardRef as ReactComponent };